import React from "react";

const EmployeeCountBlock = ({
  label,
  errorPrefix,
  value,
  onChange,
  submitted,
  errors = {},
  readOnly = false,
}) => (
  <div className="mb-3">
    <label className="st_name d-block mb-2">{label} *</label>
    <div className="row">
      {["male", "female", "others"].map((key) => {
        const fieldErr = errors[`${errorPrefix}_${key}`];
        return (
          <div className="col-md-4" key={`${label}-${key}`}>
            <input
              className="form-control name_nf"
              type="number"
              min="0"
              required={!readOnly}
              disabled={readOnly}
              readOnly={readOnly}
              placeholder={key.charAt(0).toUpperCase() + key.slice(1)}
              value={value[key]}
              onChange={(e) => onChange({ ...value, [key]: e.target.value })}
            />
            {submitted && fieldErr ? (
              <div className="help-block">{fieldErr}</div>
            ) : null}
          </div>
        );
      })}
    </div>
  </div>
);

export default EmployeeCountBlock;
